import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {
  public dynamicLabels = signal<Record<string, string>>({});

  setLabel(key: string, label: string): void {
    if (this.dynamicLabels()[key] === label) {
      return;
    }

    this.dynamicLabels.update(labels => ({
      ...labels,
      [key]: label,
    }));
  }

  getLabel(key: string): string | undefined {
    return this.dynamicLabels()[key];
  }

  getDynamicLabels() {
    return this.dynamicLabels();
  }

  clearLabel(key: string): void {
    if (!this.dynamicLabels()[key]) {
      return;
    }

    this.dynamicLabels.update(labels => {
      const newLabels = { ...labels };
      delete newLabels[key];
      return newLabels;
    });
  }

  clearAll(): void {
    if (Object.keys(this.dynamicLabels()).length === 0) {
      return;
    }
    this.dynamicLabels.set({});
  }
}
